import type {ShowThesaurusCode} from 'schemaDefinition/types';
import type {ThesaurusNode} from 'services/thesaurus/types';
import {getNodeDisplayCode} from './getNodeDisplayCode';

export const formatNodeTitle = (
  node: ThesaurusNode,
  showCodes: ShowThesaurusCode = false,
  forNodeTypes: string[] | undefined = undefined,
): string => {
  const code = getNodeDisplayCode(node, showCodes, forNodeTypes);
  return code ? `(${code}) ${node.label}` : node.label;
};
